import { QueryCache, QueryClient } from "@tanstack/react-query"
import { isTest } from "./env"

export const queryCache = new QueryCache()

export const setQueryCache = (ms: number, refetch: boolean | "always" = false) => ({
  gcTime: ms,
  staleTime: ms,
  refetchOnWindowFocus: refetch,
})

export type QueryCacheConfig = ReturnType<typeof setQueryCache>

export const makeQueryClient = (cache?: QueryCacheConfig) => {
  cache = cache || setQueryCache(0)

  return new QueryClient({
    queryCache,
    defaultOptions: {
      queries: {
        ...cache,
        retry: isTest ? 0 : 1,
        refetchOnWindowFocus: !isTest,
        refetchOnReconnect: !isTest,
      },
      mutations: {
        retry: 0,
      },
    },
  })
}

export const queryKeys = {
  auth: ["auth"],
  config: ["config"],
}
